<template>
  <div class="accountChecking_Box">
    <el-card shadow="always">
      <div class="accountChecking_Tab">
        <el-radio-group v-model="merchantRadio">
          <el-radio-button label="1">商户号对账单</el-radio-button>
          <el-radio-button label="2">平台商户对账单</el-radio-button>
        </el-radio-group>
      </div>
      <!-- 商户号对账单 -->
      <MerchantMark v-if="merchantRadio === '1'" />
      <!-- 平台商户对账单 -->
      <PlatformMerchant v-if="merchantRadio === '2'" />
    </el-card>
  </div>
</template>

<script>
import MerchantMark from "./modules/merchantMark.vue";
import PlatformMerchant from "./modules/platformMerchant.vue";
export default {
  components: { MerchantMark, PlatformMerchant },
  data() {
    return {
      merchantRadio: sessionStorage.getItem("MerchantRadio") || "1",
    };
  },
  watch: {
    merchantRadio: {
      handler(to) {
        sessionStorage.setItem("MerchantRadio", to);
      },
    },
  },
};
</script>